const useFilterLocationCompute = ({
	countriesList = [],
	regionsList = [],
} = {}) => {
	// ** Zwraca 'apiParam' kraju na podstawie 'url',
	const countryUrlToApiParam = (value) => {
		if (value) {
			const id = Object.entries(countriesList).find(
				([, { url }]) => url === value
			)?.[0];

			if (id) {
				return id;
			}
		}
		return null;
	};

	// ** Zwraca 'url' kraju na podstawie 'id',
	const countryIdToUrl = (value) => {
		if (value) {
			return countriesList[value].url;
		}
		return null;
	};

	// ** Zwraca 'apiParam' regionu na podstawie 'url',
	const regionUrlToApiParam = (value) => {
		if (value) {
			const searchValue =
				regionsList?.regions &&
				Object.entries(regionsList.regions).find(
					([, { url }]) => url === value
				);

			if (searchValue) {
				const [, { id }] = searchValue;
				return id;
			}
		}
		return null;
	};

	// ** Zwraca 'url' regionu na podstawie 'id',
	const regionIdToUrl = (value) => {
		if (value) {
			return regionsList.regions[value].url;
		}
		return null;
	};

	// ** Zwraca 'apiParam' miasta na podstawie 'url',
	const cityUrlToApiParam = (value, regionUrl) => {
		if (value) {
			const regionSearch =
				regionsList?.regions &&
				Object.entries(regionsList.regions).find(
					([, { url }]) => url === regionUrl
				);

			if (!regionSearch) {
				return null;
			}

			const { id } = Object.entries(regionSearch[1].cities).find(
				([, { url }]) => url === value
			)[1];
			return id;
		}
		return null;
	};

	// ** Zwraca 'url' miasta na podstawie 'id',
	const cityIdToUrl = (value, regionId) => {
		if (value && regionId) {
			return regionsList.regions[regionId].cities[value].url;
		}
		return null;
	};

	// ** Zwraca 'apiParam' wybranego dystansu na podstawie 'url',
	const distanceUrlToApiParam = (value) => {
		if (!value) return null;
		return Number(value);
	};

	return {
		countryUrlToApiParam,
		countryIdToUrl,
		regionUrlToApiParam,
		regionIdToUrl,
		cityUrlToApiParam,
		cityIdToUrl,
		distanceUrlToApiParam,
	};
};

export default useFilterLocationCompute;
